import { useState } from "react";
import { ALPHA__Drawer as Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import {
  ExplainerType,
  SkinMatchIngredientData,
} from "../../../../hooks/useSkinMatch/skinMatchSchema";
import styles from "./IngredientDetail.module.scss";

type Props = {
  data: SkinMatchIngredientData;
};

export const IngredientDetail = ({ data }: Props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [inciName, setInciName] = useState<string>("");
  const [ingredientDetail, setIngredientDetail] = useState<ExplainerType>();

  const handleClose = () => {
    setDrawerIsOpen(false);
  };
  return (
    <div data-testid="ingredient:detail" className={styles.skinMatchApi}>
      <p className={styles.helperText}>
        Click on an ingredient to see its source, uses and effects. All
        ingredients are listed in descending order by weight.
      </p>
      <div className={styles.ingredientLists}>
        {data.map(({ inci_name, inci_id, explainer }) => {
          const inciName = inci_name.toLocaleLowerCase();
          return (
            <div
              role="listItem"
              className={styles.ingredientList}
              key={inci_id}
              tabIndex={0}
              data-text={inciName}
              onClick={() => {
                setInciName(inciName);
                setIngredientDetail(explainer);
                setDrawerIsOpen(true);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setInciName(inciName);
                  setIngredientDetail(explainer);
                  setDrawerIsOpen(true);
                }
              }}
            >
              {inciName}
            </div>
          );
        })}
      </div>
      <div className={styles.disclamier}>
        <div className={styles.disclamierTitle}>Disclaimer:</div>
        The ingredients list and details are provided by Skin Match Technology
        for information purposes only. Formulation and ingredients are subject
        to change by the brand. Please refer to the product packaging for the
        most up-to-date ingredients list and be aware that it may change or vary
        from time to time. For any concerns please seek professional advice
        before use.
      </div>
      <Drawer
        header="Ingredients"
        isOpen={drawerIsOpen}
        onClose={handleClose}
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        rootId="page-root"
        footerChildren={
          <p className={styles.poweredBy}>Powered by Skin Match Technology</p>
        }
      >
        <p className={styles.detailTitle}>
          More about <span>{inciName}</span>
        </p>
        <ul className={styles.detailList}>
          {ingredientDetail &&
            Object.entries(ingredientDetail).map(([key, value]) => {
              return value.map((v, i) => (
                <li className={styles.detailListItem} key={key + i}>
                  {v}
                </li>
              ));
            })}
        </ul>
      </Drawer>
    </div>
  );
};
